import { render, staticRenderFns } from "./rightTab.vue?vue&type=template&id=77c05657&scoped=true&"
import script from "./rightTab.vue?vue&type=script&lang=js&"
export * from "./rightTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c05657",
  null
  
)

export default component.exports